import type { VideoRequestController, VideoRequestStatus } from '@saas/api-client';

export const REQUEST_STATUS_FILTERS = [
	'SENT',
	'NOT_DELIVERED',
	'OPENED',
	'UPLOADING',
	'RECEIVED',
	'EXPIRED',
] as const satisfies readonly VideoRequestStatus[];

export const DEFAULT_REQUEST_PAGE_SIZE = 25;

/** The Requests tab's URL state is the list query itself; anything unset reads as its default. */
export type RequestsSearch = NonNullable<Parameters<VideoRequestController['list']>[0]['query']>;
